import logoCompleto from "@/assets/pm-one.jpg";
import marca from "@/assets/pm-one-marca.svg";
import { cn } from "@/lib/utils";

/**
 * ─────────────────────────────────────────────────────────────────────────────
 *  A marca do PM ONE
 *
 *  Num sítio só, e não copiada para a sidebar, o login e o resto: um logo que
 *  vive em três ficheiros diverge no primeiro ajuste de tamanho.
 *
 *  ── A placa branca, nos DOIS temas ─────────────────────────────────────────
 *  O ficheiro é um JPEG com fundo branco opaco e texto azul-marinho. Em modo
 *  escuro, sem placa, ficava um retângulo branco recortado no meio da barra; e
 *  se lhe tirássemos o fundo, o texto marinho desaparecia contra o escuro.
 *
 *  A placa aplica-se nos dois temas de propósito. Pô-la só no escuro faria o
 *  logo mudar de aparência ao alternar o tema — mais discreto num, estranho no
 *  outro, e inconsistente nos dois.
 *
 *  Quando existir um SVG com fundo transparente, troca-se o import e apaga-se
 *  a placa. Mais nada muda.
 * ─────────────────────────────────────────────────────────────────────────────
 */

/** O lockup completo: PM ◆ ONE · BY TGT ISG. */
export function Marca({
  className,
  altura = "h-8",
}: {
  className?: string;
  /** Classe de altura do Tailwind. A largura acompanha, 3.7:1. */
  altura?: string;
}) {
  return (
    <span
      className={cn(
        // `w-fit` e não `self-start`: dentro do grid do `CardHeader`,
        // `self-start` alinha no eixo de bloco e a placa continuava a esticar
        // para a largura toda do cartão — o logo passava a parecer um banner.
        "inline-flex w-fit shrink-0 items-center rounded-md bg-white px-2 py-1",
        className,
      )}
    >
      <img
        src={logoCompleto}
        alt="PM ONE, por TGT ISG"
        className={cn(altura, "w-auto")}
      />
    </span>
  );
}

/**
 * Só o losango.
 *
 * A sidebar colapsa para modo ícone — `collapsible="icon"`, porque as grelhas
 * deste produto têm 40 a 60 colunas e precisam da largura toda. O lockup tem
 * proporção 3.7:1 e não cabe nesse espaço; o losango é quadrado e cabe.
 *
 * É SVG desenhado a partir da medição do ficheiro original — no JPEG é um
 * quadrado de 140×140 rodado 45°, e as duas cores saíram da amostragem dos
 * píxeis, não de estimativa. Recortar o JPEG daria uma bola branca à volta.
 */
export function MarcaIcone({ className }: { className?: string }) {
  return (
    <img
      src={marca}
      alt="PM ONE"
      className={cn("size-8 shrink-0", className)}
    />
  );
}
